import { fetchAllOutilsPratiquesApi } from "../../../api/ToolsApi";
import StickySearchbar from "../../../components/molecules/stickySearchbar/StickySearchbar";
import TextHr from "../../../components/molecules/textHr/TextHr";
import ExpendableGroup from "../../../components/organisms/expendableGroup/ExpendableGroup";
import Loader from "../../../components/organisms/loader/Loader";
import PracticalTool from "../../../components/organisms/practicalTool/PracticalTool";
import AppContext from "../../../context/AppContext";
import { useAuth } from "../../../context/AuthContext";
import { normalizeString } from "../../../utils/Utils";
import "./PracticalTools.css";
import React, { Fragment, useContext, useEffect, useState } from "react";

function PracticalTools() {
  const { createNotification, setBannerConfig } = useContext(AppContext);
  const [searchValue, setSearchValue] = useState("");
  const [tools, setTools] = useState([]);
  const [displayedTools, setDisplayedTools] = useState([]);
  const [activeExpendableGroupIndex, setActiveExpendableGroupIndex] = useState(-1);

  useEffect(() => {
    fetchPracticalTools();
    setBannerConfig({
      title: <>Outils pratiques</>,
      subtitle: <>Téléchargez nos outils exclusifs pour vous aider à optimiser, céder ou acquérir une affaire</>,
    });
  }, []);

  useEffect(() => {
    if (!searchValue.length) return onSearch(searchValue);

    const timeout = setTimeout(() => {
      onSearch(searchValue);
    }, 500);

    return () => clearTimeout(timeout);
  }, [searchValue]);

  async function fetchPracticalTools() {
    try {
      const tmp = {};
      const res = (await fetchAllOutilsPratiquesApi()).data;
      const tools = [];

      console.log("Outils pratiques récupérés :", res);

      res.forEach(tool => {
        if (tmp[tool.tag_id]) {
          tmp[tool.tag_id].push(tool);
        } else {
          tmp[tool.tag_id] = [tool];
        }
      });

      for (const [key, value] of Object.entries(tmp)) {
        tools.push({
          tagId: key,
          tools: value.sort((a, b) => a.category_display_order - b.category_display_order),
          tagName: value[0].tag_name,
        });
      }

      setTools(tools);
      setDisplayedTools(tools);
    } catch (error) {
      createNotification(
        <>Une erreur est survenue lors de la récupération des outils pratiques. Veuillez réessayer</>,
        "var(--red)",
        "var(--dark-blue",
      );
    }
  }

  function onSearch(searchValue) {
    if (!searchValue.length) return setDisplayedTools(tools);

    const filteredTools = tools
      .map(category => ({
        ...category,
        tools: category.tools.filter(tool => normalizeString(tool.name).includes(normalizeString(searchValue))),
      }))
      .filter(category => category.tools.length);

    setDisplayedTools(filteredTools);
  }

  return (
    <>
      <div className='page-container container'>
        <StickySearchbar onChange={setSearchValue} />
        {tools.length ? (
          <>
            {displayedTools.map(category => (
              <Fragment key={category.tagId}>
                <TextHr className='practical-tools-hr'>{category.tagName}</TextHr>
                <ExpendableGroup
                  closeAllTrigger={activeExpendableGroupIndex !== category.tagId}
                  onOpenExpendable={() => setActiveExpendableGroupIndex(category.tagId)}
                  data={category.tools.map(tool => ({
                    title: tool.name,
                    content: <PracticalTool tool={tool} />,
                  }))}
                />
              </Fragment>
            ))}
            {!displayedTools.length && (
              <p className='text-xl text-center outfit-semibold'>Aucun résultat ne correspond à votre recherche</p>
            )}
          </>
        ) : (
          <Loader className='practical-tools-loader' visible preventScrolling={false} />
        )}
      </div>
    </>
  );
}

export default PracticalTools;
